"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useLicenseVerifier", {
  enumerable: true,
  get: function () {
    return _useLicenseVerifier.useLicenseVerifier;
  }
});
var _useLicenseVerifier = require("./useLicenseVerifier");